import { Trans, useTranslation } from "react-i18next";
import "./GeoBIM.scss";
import geobimGesamt from "../../images/GeoBim/geobim-gitter.jpg";
import imageDE from "../../images/geo-bim-de.png";
import imageEN from "../../images/geo-bim-en.png";
import imageES from "../../images/geo-bim-es.png";
import ischebeckLogo from "../../images/Ischebeck_Logo2013_VarA_RGB_1zu1_trans.svg";
import findGeoBimDE from "../../images/finde-GeoBIM.jpg";
import findGeoBimEN from "../../images/find-GeoBIM.jpg";
import { useLazyGetGeoBimDownloadUrlQuery } from "../../services/API/DownloadAPI";
import { faChevronLeft, faChevronRight, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GeoBIM = ({ onClose }) => {
  const { t, i18n } = useTranslation("translation");
  const [downloadGeoBim, { isLoading }] = useLazyGetGeoBimDownloadUrlQuery();

  const handleVideoClick = () => {
    window.open("https://youtu.be/_VVhiQLskq0?si=Ga2oxbWK9SQ2Cv0T", "_blank");
  };

  const handleDownloadClick = async () => {
    if (isLoading) return;
    try {
      const response = await downloadGeoBim().unwrap();

      if (response?.url) {
        // Construct full URL using backend base URL
        const backendUrl =
          import.meta.env.VITE_BACKEND_BASE_URL + ":" + import.meta.env.VITE_BACKEND_PORT;
        const fullUrl = response.url.startsWith("http")
          ? response.url
          : `${backendUrl}${response.url}`;

        window.open(fullUrl, "_blank");
      } else {
        console.error("No download URL received. Response:", response);
      }
    } catch (error) {
      console.error("Failed to download GeoBIM tool:", error);
    }
  };

  const handleBackClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="geobim-fullscreen">
      <div className="geobim-left">
        <div className="left-image">
          <img src={geobimGesamt} alt="GeoBIM Overview" />
          <div className="overlay-text">
            <img
              src={
                i18n.language === "de-DE" ? imageDE : i18n.language === "es-ES" ? imageES : imageEN
              }
              style={{ width: "100%" }}
              alt=""
            />
          </div>
        </div>
        <div className="left-logo">
          <img src={ischebeckLogo} alt="Ischebeck TITAN" />
        </div>
      </div>

      <div className="geobim-right">
        <div className="right-content">
          <h2>{t("geobim.whatIsTitle")}</h2>
          <p className="description">{t("geobim.description")}</p>

          <h3>{t("geobim.advantagesTitle")}</h3>
          <ul className="advantages-list">
            <li>{t("geobim.advantage1")}</li>
            <li>{t("geobim.advantage2")}</li>
            <li>{t("geobim.advantage3")}</li>
            <li>{t("geobim.advantage4")}</li>
            <li>{t("geobim.advantage5")}</li>
            <li>{t("geobim.advantage6")}</li>
          </ul>

          <h3>{t("geobim.videoTitle")}</h3>
          <p>{t("geobim.videoDescription")}</p>
          <button className="geobim-btn video-btn" onClick={handleVideoClick}>
            <FontAwesomeIcon color="black" icon={faChevronRight} />
            <span style={{ marginLeft: "8px" }}>{t("geobim.videoButton")}</span>
          </button>

          <h3>{t("geobim.downloadTitle")}</h3>
          <p>{t("geobim.downloadDescription")}</p>
          <button
            className="geobim-btn download-btn"
            onClick={handleDownloadClick}
            disabled={isLoading}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              {isLoading ? (
                <FontAwesomeIcon color="black" icon={faSpinner} spin />
              ) : (
                <FontAwesomeIcon color="black" icon={faChevronRight} />
              )}
              <span style={{ marginLeft: "8px" }}>
                {isLoading ? t("geobim.downloadInProgress") : t("geobim.downloadButton")}
              </span>
            </span>
          </button>

          <p>
            <Trans i18nKey="geobim.helptext-1" />
          </p>
          <p className="mt-3">{t("geobim.helptext-2")}</p>
          <img
            className="help-image"
            src={i18n.language === "de-DE" ? findGeoBimDE : findGeoBimEN}
            alt="GeoBIM im Revit-Menüband"
          />

          <button className="back-btn" onClick={handleBackClick}>
            <FontAwesomeIcon color="white" icon={faChevronLeft} />
            <span style={{ marginLeft: "8px" }}>{t("geobim.backButton")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GeoBIM;
